import { render, staticRenderFns } from "./AddOrderTemplate.vue?vue&type=template&id=850be108&scoped=true&"
import script from "./AddOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./AddOrderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderTemplate.vue?vue&type=style&index=0&id=850be108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850be108",
  null
  
)

/* custom blocks */
import block0 from "./AddOrderTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports